import React from 'react';
import { MessageCircle, GraduationCap } from 'lucide-react';

/**
 * AdvisorRibbon — slim CTA shown above the Footer on browse pages
 * (courses / exams / scholarships). Encourages users to chat with an
 * advisor on WhatsApp before purchasing or applying.
 *
 * Mobile-first: stacks vertically below sm, side-by-side on sm+.
 */
const WHATSAPP_NUMBER = '917330688844'; // +91 73306 88844
const WHATSAPP_MESSAGE =
  'I am looking for Scholarship Abroad & Scholarship assistance on Nerd Nation programs';

const buildWhatsappUrl = () => {
  const text = encodeURIComponent(WHATSAPP_MESSAGE);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
};

const AdvisorRibbon = () => {
  return (
    <section
      data-testid="advisor-ribbon"
      className="bg-gradient-to-br from-white via-amber-50 to-white border-y border-amber-200 px-4 py-6 sm:py-8"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <GraduationCap className="w-4 h-4 text-amber-700" />
            <span className="text-amber-700 text-[11px] font-semibold uppercase tracking-widest">
              Need Guidance?
            </span>
          </div>
          <h2 className="text-gray-900 text-lg sm:text-xl font-bold leading-snug">
            Want to Study Abroad with Full Scholarships?
          </h2>
          <p className="text-gray-700 text-sm sm:text-base mt-1 leading-relaxed">
            Want a Scholarship to study any of our Programs?
          </p>
        </div>

        <a
          href={buildWhatsappUrl()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="advisor-ribbon-cta"
          className="inline-flex items-center justify-center gap-2 shrink-0 px-5 py-3 rounded-xl bg-gradient-to-r from-amber-600 to-orange-600 text-white text-sm font-semibold shadow-sm hover:from-amber-500 hover:to-orange-500 active:scale-95 transition-all duration-150"
        >
          <MessageCircle className="w-4 h-4" />
          Talk to an Advisor
        </a>
      </div>
    </section>
  );
};

export default AdvisorRibbon;
